<script setup>
import NotificationTaskMenu from '@/components/menu/NotificationTaskMenu.vue';
import SidebarMobileMenu from '@/components/menu/SidebarMobileMenu.vue';
import AccountDropdownMenu from '@/components/menu/AccountDropdownMenu.vue';
import LogoMenu from '../menu/LogoMenu.vue';

const emits = defineEmits(['click', 'toggleAccordion']);

function handleLinkClick(args) {
  emits('click', args);
}

function trackAccordionEvent(details) {
  emits('toggleAccordion', details);
}
</script>

<template>
  <div>
    <div :class="$style['header']">
      <LogoMenu mobile />
      <div :class="$style['corner-menu']">
        <NotificationTaskMenu />
        <SidebarMobileMenu
          @click="handleLinkClick"
          @toggleAccordion="trackAccordionEvent"
        />
        <AccountDropdownMenu @click="handleLinkClick" />
      </div>
    </div>
    <router-view :class="$style.page" />
  </div>
</template>

<style lang="less" module>
.header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 1.55rem 1.25rem 1.25rem;
  height: 75px;
  transition: background-color 0.2s ease-out;
  width: 100%;
  z-index: 3;
  &.scrolled {
    z-index: 4;
    background: @color-grey-50;
    filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.06));
    @media only screen and (max-width: @wayfinding-tablet-width) {
      background: @color-white;
    }
  }
  .corner-menu {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: colum;
    z-index: 3;
  }
  .mobile-menu-button {
    background: none;
    display: none;
    z-index: 2;
    @media only screen and (max-width: @wayfinding-tablet-width) {
      display: block;
      padding: 0 7px 4px;
    }
  }
}
.page {
  padding: 0 20px;
  margin: 0 auto;
  @media only screen and (max-width: @wayfinding-tablet-width) {
    left: 0;
  }
}
</style>
